import React from 'react';

const Footer = ({ onShowPrivacy, onShowTerms, onNavigateToAbout }) => (
  <footer
    className="relative py-12 bg-gray-800 text-gray-300"
    style={{ zIndex: 10 }}
  >
    <div className="max-w-6xl mx-auto px-8 text-center">
      <h3 className="text-xl font-semibold tracking-widest text-white mb-4 font-header">
        TOWER-INTEGRATIONS
      </h3>
      <div className="flex justify-center space-x-6 mb-6 font-header text-base">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onShowPrivacy();
          }}
          className="hover:text-white cursor-pointer"
        >
          Privacy Policy
        </a>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            onShowTerms();
          }}
          className="hover:text-white cursor-pointer"
        >
          Terms of Service
        </a>
        <button
          onClick={() => onNavigateToAbout && onNavigateToAbout()}
          className="hover:text-white transition-colors"
        >
          About
        </button>
      </div>
      <p className="text-base text-gray-400">
        &copy; {new Date().getFullYear()} Tower-Integrations. All Rights
        Reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
